import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement } from 'react';
import { StyledCircleDone, StyledCircleCurrent, StyledCircleNew, StyledDash, StatusWrapper, } from './Status.styles';
export function Status({ currentStep: step, steps = 3, disabled }) {
    const elements = [];
    for (let i = 0; i < steps; i += 1) {
        if (step === i) {
            elements.push(_jsx(StyledCircleCurrent, { disabled: disabled }));
        }
        else if (step > i) {
            elements.push(_jsx(StyledCircleDone, { disabled: disabled }));
        }
        else {
            elements.push(_jsx(StyledCircleNew, { disabled: disabled }));
        }
        if (i !== steps - 1)
            elements.push(_jsx(StyledDash, { disabled: disabled }));
    }
    const elementsWithKeys = elements.map((element, index) => cloneElement(element, { key: String(index) }));
    return _jsx(StatusWrapper, { children: elementsWithKeys });
}
